import "./index.css";

import { Fragment } from "react";

import {
  AppBar,
  Box,
  Button,
  Container,
  CssBaseline,
  Toolbar,
  Typography,
} from "@mui/material";
import { BrowserRouter, Link, Route, Routes } from "react-router";
import { SignUpPage } from "./components/SignUpPage";
import { HomePage } from "./components/HomePage";
import { LoginPage } from "./components/LoginPage";

export function App() {
  return (
    <Fragment>
      <CssBaseline />
      <BrowserRouter>
        <AppBar position="static">
          <Container maxWidth="sm">
            <Toolbar disableGutters>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                Nascar Pickems
              </Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button color="inherit" component={Link} to="/">
                  Home
                </Button>
                <Button color="inherit" component={Link} to="/signup">
                  Sign Up
                </Button>
                <Button color="inherit" component={Link} to="/login">
                  Login
                </Button>
              </Box>
            </Toolbar>
          </Container>
        </AppBar>

        <Container maxWidth="sm" sx={{ mt: 3 }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/login" element={<LoginPage />} />
          </Routes>
        </Container>
      </BrowserRouter>
    </Fragment>
  );
}

export default App;
